import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import studylistContext from "../../context/studylist/StudylistContext";
import { initiateBulkDownload } from "../../service/StudyListService";
import LoadingBar from "react-top-loading-bar";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getExpandedRowModel,
  createRow,
  expandRows,
  RowSelection,
} from "@tanstack/react-table";
import {
  Checkbox,
  DefaultButton,
  Icon,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  TooltipHost,
  ContextualMenu,
} from "@fluentui/react";
import {
  ADVANCE_VIEWER_MODALITIES,
  ARCHIVED_STUDY_TABS_NAME,
  CXR_TABS_NAME,
  HIDE_LOCK_ICON_TABS,
  PEER_REVIEW_TABS,
  PEER_REVIEW_TABS_NAME,
  QC_REVIEW_TABS_NAME,
  QC_TABS,
  QC_TABS_NAME,
  REACT_ADVANCE_VIEWER_URL,
  REPORTDONESTATUS,
  REPORT_DONE_STATUS,
  REPORTED_TABS_NAME,
  RESTRICTED_STORAGE_TYPES,
  SAVED_TABS_NAME,
  STORAGE_TYPE,
  TAB_NAME,
  TOAST_TYPE,
  USERTYPES,
  widthOfColumns,
  ORDER_ID_COLORS
} from "../../constants/Constants";
import PlatformHelper from "../../helpers/PlatformHelper";
import ConfirmModal from "../Modal/ConfirmModal";

import { t } from "i18next";
import {
  getReturnStudyStatus,
  getStudyStatus,
  sendOldStudyAccessRequest,
  sendOldStudyAccessRequest2,
} from "../../service/StudyListService";
import { CSSTransition, Transition } from "react-transition-group";
import ImageArchivalAccessForm from "../../pages/StudyList/components/Modal/ImageArchive/ImageArchivalAccessForm";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import ShimmerStudyRows from "../../pages/StudyList/components/ShimmerStudyList/ShimmerStudyRows";
import themeContext from "../../context/theme/ThemeContext";
import userContext from "../../context/users/UserContext";
import AlertSuccessModal from "../AlertSuccessModal/AlertSuccessModal";
import loaderContext from "../../context/loader/LoaderContext";
import { getEnv } from '../../helpers/EnvHelper';
const DesktopStudyListTable = (props) => {
  const { ref, setLoaderRunning } = useContext(loaderContext);
  
  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;

  const {
    filterInputValues,
    showCount,
    setShowCount,
    refreshRequired,
    setRefreshRequired,
    storedRows,
    setStoredRows,
    studyListLoading,
    setStudyListLoading,
    studyListRef,
    dataQueryState,
    setDataQueryState,
    showViewer,
    updateLockUnlockRows,
    setUpdateLockUnlockRows,
    setSearchResultLength,
    menuItemsForBatchAndInference,
    rowSelectionState,
    setRowSelectionState,
    setRowSelectedArray,
    rowSelectedArray,
    getCountOfAbleToDeleteStudies,
    handleBatchReInference,
    batchReinferenceAndDeleteArray,
    resetRowSelection,
    setResetRowSelection,
    handleBatchDelete,
    handleBatchImageDelete,
    unreportedAllTabs,
    fetchData,
    roles,
    userId,
    trackOfVisisted,
    setTrackOfVisited,
    returnedReasonCount,
    setReturnedReasonCount,
    selectedValue,
    maintenance,
    twoMonitorEnabled,
    setTwoMonitorEnabled,
    maxBulkReportDownload,
    handleBatchReportDownload,
    xrayReportType, setXrayReportType,
    nonXrayReportType, setNonXrayReportType
  } = useContext(studylistContext);

  const { qcOpenStudyDisabled, showPasswordExpiryMessage } = useContext(userContext)

  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;

  // const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(false);
  // const [studyList, setStudyList] = useState([]);
  // const fetchStudyList = async () => {
  //   try {
  //     const data = await getStudyList(); 
  //     setTwoMonitorEnabled(data.data.data.twoMonitorEnabled);
  
  //   } catch (error) {
  //     console.error('Error fetching study list:', error);
  //   }
  // };

  // useEffect(() => {
  //   fetchStudyList(); 
  // }, []);
  const {
    updateRowSubmitDone,
    setUpdateDoneSubmitDone,
    alertSuccessModal,
    hideAlertSuccessModal,
    setAlertSuccessModal
  } = useContext(studyReportContext);
  const {contextSwitchUser, priviledgedFirmTechnician, showViewerTechnician} = useContext(userContext);

  const { isActiveData } = useContext(userContext);

  const linkRef = useRef(null);

  const [openImageArchiveConfirmation, setOpenImageArchiveConfirmation] =
    useState(false);
  const [openImageArchivalForm, setOpenImageArchivalForm] = useState(false);
  const [
    openImageArchivalAccessConfirmation,
    setOpenImageArchivalAccessConfirmation,
  ] = useState(false);
  const [
    openImageArchivalAccessConfirmationMessage,
    setOpenImageArchivalAccessConfirmationMessage,
  ] = useState(false);

  const dataQuery = props.dataQuery;
  const table = props.table;

  const [doubleClickedRow, setDoubleClickedRow] = useState(null);
  const { themeName, getThemeColor } = useContext(themeContext);
  const [showBatchDeleteContextualMenu, setShowBatchDeleteContextualMenu] =
    useState(false);
  const [delayHandler, setDelayHandler] = useState(null);
  const [downloadType, setDownloadType] = useState('');
  
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;
  const isRadiologist = props.roles?.[0] === USERTYPES.RADIOLOGIST;
  const getOrderColor = (orderId) => {
    if (!orderId) return null;

    let hash = 0;
    for (let i = 0; i < orderId.length; i++) {
      hash = orderId.charCodeAt(i) + ((hash << 5) - hash);
    }

    return ORDER_ID_COLORS[Math.abs(hash) % ORDER_ID_COLORS.length];
  };
  
  // useEffect(() => {

  //   const updateMonitorStatus = async () => {
  //     //twoMonitorEnabled
  //     if(twoMonitorEnabled){
  //        const istwoMonitorEnabled = await checkMonitors();
  //         setTwoMonitorEnabled(istwoMonitorEnabled);
  //     }
  //   };

  //   // Initialize the monitor check
  //   updateMonitorStatus();
  // }, []);

  const spinnerStyle = {
    circle: {
      height: "30px",
      width: "30px",
      borderWidth: "3px",
    },
    label: {
      color: "white",
    },
  };

  const handleSavedRowRemove = (studyId) => {
    table.options.meta?.removeRowFromStudyList(studyId);
    setRefreshRequired(() => handleRefreshTabs([TAB_NAME.SAVED]));
  };
  useEffect(() => {
    if (updateRowSubmitDone != undefined && updateRowSubmitDone.show) {
      let assignmentId = -1;
      let newData = dataQueryState?.data?.rows.filter((row, index) => {
        if (row.id === updateRowSubmitDone.id) {
          assignmentId = row.assignmentList[0].id;
          return true;
        }
        return false;
      });
      setUpdateDoneSubmitDone(() => {
        const newItem = { ...updateRowSubmitDone };
        newItem.id = null;
        newItem.show = false;
        return newItem;
      });
      if (roles[0] != USERTYPES.TYPIST) {
        handleBeforeUnload(
          updateRowSubmitDone.id,
          assignmentId,
          dataQueryState.data.rows
        );
      } else {
        handleSavedRowRemove(updateRowSubmitDone.id);
      }
    }
  }, [updateRowSubmitDone]);

  const setRefreshRequiredForTab = (tab) => {
    setRefreshRequired({
      ...refreshRequired,
      tab: { id: tab, alreadyLoaded: false },
    });
  };

  const handleUpdateRowReportDoneState = (
    studyId,
    reportDoneStatus,
    allData
  ) => {
    let newIndex = -1;
    let newData = allData?.filter((row, index) => {
      if (row.id === studyId) {
        newIndex = index;
        return true;
      }
      return false;
    });
    if (allData != undefined) {
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        allData[newIndex].assignmentList[0].reportDoneStatus = reportDoneStatus;
        allData[newIndex].assignmentList[0].colorClassName = "";
        newValue.data.rows = allData;
        newValue.data.pageCount = allData.length;
        return newValue;
      });
    }
  };

  const handleRefreshTabs = (refreshRequiredTabs) => {
    const tabs = { ...refreshRequired };
    refreshRequiredTabs.forEach((tab) => (tabs[tab].alreadyLoaded = false));
    return tabs;
  };

  const handleUnreportedTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.REPORTED]));
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.SAVED:
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.SAVED]));
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.DRAFT:
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.DRAFT]));
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCREVIEW:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_REVIEW:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.QCREVIEW, TAB_NAME.QCREVIEWASSIGNED, TAB_NAME.UNREPORTED])
        );
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCFIX:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_FIX:
        handleUpdateRowReportDoneState(studyId, newReportDoneStatus, allData);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.QCFIX, TAB_NAME.UNREPORTED])
        );
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCVERIFY:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_VERIFY:
        handleUpdateRowReportDoneState(studyId, newReportDoneStatus, allData);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.QCVERIFY, TAB_NAME.UNREPORTED])
        );
        break;

      case maxAiEmergency == REPORT_DONE_STATUS.MARK_AS_SUSPECTED:
        table.options.meta?.updateTriageDetailFromStudyList(
          studyId,
          maxAiEmergency
        );
        setRefreshRequired(() =>
          handleRefreshTabs([
            TAB_NAME.NORMAL,
            TAB_NAME.NORMALWITHFB,
            TAB_NAME.ABNORMAL,
          ])
        );
        break;

      default:
        return null;
    }
  };

  const handleSavedTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.REPORTED, TAB_NAME.UNREPORTED])
        );
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCREVIEW:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_REVIEW:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.SAVED, TAB_NAME.UNREPORTED, TAB_NAME.QCREVIEW, TAB_NAME.QCREVIEWASSIGNED])
        );
        break;

      case maxAiEmergency == REPORT_DONE_STATUS.MARK_AS_SUSPECTED:
        table.options.meta?.updateTriageDetailFromStudyList(
          studyId,
          maxAiEmergency
        );
        setRefreshRequired(() =>
          handleRefreshTabs([
            TAB_NAME.NORMAL,
            TAB_NAME.NORMALWITHFB,
            TAB_NAME.ABNORMAL,
          ])
        );
        break;

      default:
        break;
    }
  };

  const handleReviewPendingTabRowChange = () => {}

  const handleQCReviewTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY:
      case newReportDoneStatus === REPORT_DONE_STATUS.SAVED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.REPORTED, TAB_NAME.SAVED, TAB_NAME.UNREPORTED]));
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCFIX:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_FIX:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([
            TAB_NAME.QCREVIEW,
            TAB_NAME.QCREVIEWASSIGNED,
            TAB_NAME.QCFIX,
            TAB_NAME.UNREPORTED,
          ])
        );
        break;

      // Still in QC Review (Final 3 / Preliminary 7) — keep row after open/close
      case newReportDoneStatus === REPORT_DONE_STATUS.QCREVIEW:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_REVIEW:
      default:
        break;
    }
  };

  const handleQCVerifyTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY:
      case newReportDoneStatus === REPORT_DONE_STATUS.SAVED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.UNREPORTED, TAB_NAME.SAVED]));
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCFIX:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_FIX:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([
            TAB_NAME.QCVERIFY,
            TAB_NAME.QCFIX,
            TAB_NAME.UNREPORTED,
          ])
        );
        break;

      default:
        break;
    }
  };

  const handleQCFixTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.QCVERIFY:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY_QC_VERIFY:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.QCFIX, TAB_NAME.QCVERIFY, TAB_NAME.UNREPORTED])
        );
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
      case newReportDoneStatus === REPORT_DONE_STATUS.PRELIMINARY:
      case newReportDoneStatus === REPORT_DONE_STATUS.SAVED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.REPORTED, TAB_NAME.SAVED, TAB_NAME.UNREPORTED]));
        break;

      default:
        break;
    }
  };

  const handleReportedTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus !== REPORT_DONE_STATUS.REPORTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.UNREPORTED]));
        break;

      default:
        break;
    }
  };

  const handleLibraryTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
        // REFRESH PAGE
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCREVIEW:
        // REFRESH PAGE
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCVERIFY:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        handleUpdateRowReportDoneState(studyId, newReportDoneStatus, allData);
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCFIX:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        handleUpdateRowReportDoneState(studyId, newReportDoneStatus, allData);
        break;

      default:
        break;
    }
  };

  const handleCriticalTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() =>
          handleRefreshTabs([TAB_NAME.CRITICAL, TAB_NAME.REPORTED])
        );
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.SAVED:
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.CRITICAL]));
        break;

      case newReportDoneStatus === REPORT_DONE_STATUS.QCREVIEW ||
        newReportDoneStatus === REPORT_DONE_STATUS.QCFIX ||
        newReportDoneStatus === REPORT_DONE_STATUS.QCVERIFY:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.CRITICAL]));
        handleUpdateRowReportDoneState(studyId, newReportDoneStatus, allData);
        break;

      default:
        break;
    }
  };

  const handleNormalTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case maxAiEmergency == REPORT_DONE_STATUS.MARK_AS_SUSPECTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setRefreshRequired(() =>
          handleRefreshTabs([
            TAB_NAME.UNREPORTED,
            TAB_NAME.SAVED,
            TAB_NAME.ABNORMAL,
          ])
        );
        break;

      default:
        return null;
    }
  };

  const handleAbnormalTabRowChange = () => {};

  const handleNormalWithFBTabRowChange = (
    newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case maxAiEmergency == REPORT_DONE_STATUS.MARK_AS_SUSPECTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setRefreshRequired(() =>
          handleRefreshTabs([
            TAB_NAME.UNREPORTED,
            TAB_NAME.SAVED,
            TAB_NAME.ABNORMAL,
          ])
        );
        break;

      default:
        return null;
    }
  };

  const handleReviewAssignedTabRowChange = (newReportDoneStatus,
    studyId,
    maxAiEmergency,
    allData
  ) => {
    switch (true) {
      case newReportDoneStatus === REPORT_DONE_STATUS.REPORTED:
        table.options.meta?.removeRowFromStudyList(studyId);
        setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
        setRefreshRequired(() => handleRefreshTabs([TAB_NAME.REVIEWASSIGNED]));
        break;

      default:
        return null;
    }
  };
  const handleReviewCompleteTabRowChange = () => {};
  const handleEvaluationAssignedTabRowChange = () => {};
  const handleEvaluationCompleteTabRowChange = () => {};
  const handlePendingTabRowChange = () => {};
  const handleApprovedTabRowChange = () => {};
  const handleRejectedTabRowChange = () => {};

  const handleBeforeUnload = async (studyId, assignmentId, allData) => {
    const response = await getStudyStatus(studyId, assignmentId);
    if (response.status === 200) {
      const newReportDoneStatus = response?.data?.data?.reportDoneStatus;
      const maxAiEmergency = response?.data?.data?.maxAiEmergency;
      switch (true) {
        case props.id === TAB_NAME.UNREPORTED:
          handleUnreportedTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.SAVED:
          handleSavedTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.DRAFT:
          handleSavedTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;
        
        case props.id === TAB_NAME.REVIEWPENDING:
          handleReviewPendingTabRowChange();
          break;

        case props.id === TAB_NAME.QCREVIEW:
        case props.id === TAB_NAME.QCREVIEWASSIGNED:
          handleQCReviewTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.QCVERIFY:
          handleQCVerifyTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.QCFIX:
          handleQCFixTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case REPORTED_TABS_NAME.includes(props.id):
          handleReportedTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.LIBRARY:
          handleLibraryTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.CRITICAL:
          handleCriticalTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.NORMAL:
          handleNormalTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.ABNORMAL:
          handleAbnormalTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;

        case props.id === TAB_NAME.NORMALWITHFB:
          handleNormalWithFBTabRowChange(
            newReportDoneStatus,
            studyId,
            maxAiEmergency,
            allData
          );
          break;
        
          case props.id === TAB_NAME.REVIEWASSIGNED:
            handleReviewAssignedTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;

          case props.id === TAB_NAME.REVIEWCOMPLETE:
            handleReviewCompleteTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;

          case props.id === TAB_NAME.EVALUATIONASSIGNED:
            handleEvaluationAssignedTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;

          case props.id === TAB_NAME.EVALUATIONCOMPLETE:
            handleEvaluationCompleteTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;

          case props.id === TAB_NAME.PENDING:
            handlePendingTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;

          case props.id === TAB_NAME.APPROVED:
            handlePendingTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;
  
          case props.id === TAB_NAME.REJECTED:
            handlePendingTabRowChange(
              newReportDoneStatus,
              studyId,
              maxAiEmergency,
              allData
            );
            break;

        default:
          break;
      }
    }
  };

  const handleUpdateReturnStatusAndCount = async (
    studyId,
    assignmentId,
    allData
  ) => {
    try {
      const response = await getReturnStudyStatus(studyId, assignmentId);
      if (response.data.result == "SUCCESS") {
        if (response?.data?.data?.value1) {
          let newIndex = -1;
          let newData = allData.filter((row, index) => {
            if (row.id === studyId) {
              newIndex = index;
              return true;
            }
            return false;
          });
          setDataQueryState(() => {
            const newValue = {
              ...dataQueryState,
            };
            allData[newIndex].assignmentList[0].providerId = null;
            newValue.data.rows = allData;
            newValue.data.pageCount = allData.length;
            return newValue;
          });
        }
      }
    } catch (e) {}
  };

  async function checkMonitors() {
    if (!("getScreenDetails" in window)) {
        console.error("Multi-Screen Window Placement API is not supported in this browser.");
        return false;
    }

    try {
        const screenDetails = await window.getScreenDetails();

        if (screenDetails.screens.length > 1) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error("Error accessing screen details:", error);
        return false;
    }
}

  const openStudy = (row, dataQueryState, isCtrlClick) => {
    let url = "";
    if (
      row.original.priorsCount > 0 && row.original.showPriors &&
      getEnv("REACT_APP_SHOW_PRIORS") == "true"
    ) {


      //Opening in advance viewer from user-preference
      if (
        ((ADVANCE_VIEWER_MODALITIES.includes(row.original?.modality?.name) &&
          filterInputValues?.nonXrayAdvanceViewer && filterInputValues?.advViewerUser) || filterInputValues?.infinitViewerUser)
      ) {
        url =
          REACT_ADVANCE_VIEWER_URL +
          row.original.id +
          "?firmId=" +
          row.original.assignmentList[0].firmId;
      }else{
        url =
        "/new/study/priors/load/" +
        row.original.id +
        "?firmId=" +
        row.original.assignmentList[0].firmId;
      }
      // window.open("new/study/priors/load/" + row.original.id);
    } else {
      if (
        row.original.forceOpenInAdvanceViewer === true ||
        ((ADVANCE_VIEWER_MODALITIES.includes(row.original?.modality?.name) &&
          filterInputValues?.nonXrayAdvanceViewer && filterInputValues?.advViewerUser) || filterInputValues?.infinitViewerUser)
      ) {
        url =
          REACT_ADVANCE_VIEWER_URL +
          row.original.id +
          "?firmId=" +
          row.original.assignmentList[0].firmId;
      } else {
        url =
          "/new/study/load/" +
          row.original.id +
          "?firmId=" +
          row.original.assignmentList[0].firmId;
      }
      // window.open("new/study/load/" + row.original.id+"?firmId=" + row.original.assignmentList[0].firmId);
    }
    let w = "";
      if (isCtrlClick) {
            //use openOnSpecificScreen for permission windoow
            //use window.open to open the viewer       
          w = window.open(url, "_blank");
          window.focus();
      } else {
        if(twoMonitorEnabled) {
          w = openOnSpecificScreen(url, 1);
        } else {
          w = window.open(url, "_blank");
        }
      }
   


    if (w.addEventListener) {
      w.addEventListener("beforeunload", () => {
        handleBeforeUnload(
          row.original.id,
          row.original.assignmentList[0].id,
          dataQueryState.data.rows
        );
        if (roles.length > 0 && roles[0] == USERTYPES.RADIOLOGIST) {
          handleUpdateReturnStatusAndCount(
            row.original.id,
            row.original.assignmentList[0].id,
            dataQueryState.data.rows
          );
        }
      });
    } else if (w.attachEvent) {
      w.attachEvent("onbeforeunload", () => {
        handleBeforeUnload(
          row.original.id,
          row.original.assignmentList[0].id,
          dataQueryState.data.rows
        );
        if (roles.length > 0 && roles[0] == USERTYPES.RADIOLOGIST) {
          handleUpdateReturnStatusAndCount(
            row.original.id,
            row.original.assignmentList[0].id,
            dataQueryState.data.rows
          );
        }
      });
    }
  };

  const handleStudyRowDoubleClick = (row, isCtrlClick) => {
    let isVDCPlatform = getEnv("REACT_APP_VDC_PLATFORM");
    var providerId =
      row.original.assignmentList[0].providerId != null
        ? row.original.assignmentList[0].providerId
        : "00";
    var reviewerId = row.original.peerReviewAssignment != null && row.original.peerReviewAssignment.reviewerId != null ? 
      row.original.peerReviewAssignment.reviewerId : 0;

    if (
      row.original.storageType === STORAGE_TYPE.COLD_STORAGE &&
      roles[0] != USERTYPES.FIRMTECHNICIAN
    ) {
      if (roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN) {
        setDoubleClickedRow(row);
        setOpenImageArchiveConfirmation(true);
      } else {
        setDoubleClickedRow(row);
        setOpenImageArchivalForm(true);
      }
      return;
    } else if(isBucketManagement && RESTRICTED_STORAGE_TYPES.includes(row.original.storageType)){
       return;
      //} else if (row.original.studyInstanceUId.includes("DPTK") && !filterInputValues?.infinitViewerUser) {
      //   return;
      // NEW: block on the real condition (noOfImages === 0) as well, keeping the DPTK
      //      check as a fallback.
    } else if (
      (row.original.noOfImages === 0 || row.original.studyInstanceUId.includes("DPTK")) && !filterInputValues?.infinitViewerUser
    ) {
      console.warn(
        "[studylist][zero-image-guard] study not opened - no images present",
        {
          studyId: row.original.id,
          noOfImages: row.original.noOfImages,
          studyInstanceUId: row.original.studyInstanceUId,
        }
      );
      return;
    } else if (
      isVDCPlatform === "true" &&
      roles[0] === USERTYPES.RADIOLOGIST &&
      (String(userId) !== providerId.substring(1) && String(userId) !== String(reviewerId))
    ) {
      return false;
    }

    if(roles[0] === USERTYPES.TYPIST && (row.original.typistId!==userId && row.original.typistId!==0)){
      return false;
    }

    if(roles[0] === USERTYPES.SUPERVISOR && qcOpenStudyDisabled && ![2,4].includes(row.original.modalityId)){
      return false;
    }

    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      newValue.data.rows[row.index]["visited"] = true;
      return newValue;
    });
    setTrackOfVisited([...trackOfVisisted, row.original.id]);
    openStudy(row, dataQueryState, isCtrlClick);
  };

  const getDynamicName = (value) => {
    if (value > 1) {
      return "studies";
    }
    return "study";
  };

  useEffect(() => {
    const handleScroll = () => {
      const tableElement = document.getElementById("study-list-table");
      const navbarElement = document.getElementById("header-nav");
      const tableSizeUnreported = document.getElementsByClassName(
        "table-height-with-xray-tab"
      );
      const tableSizeOtherTabs = document.getElementsByClassName(
        "table-height-without-xray-tab"
      );
      const mainContainer = document.getElementById("main-container-div-id");
      const prevScrollTop = document.getElementById("prevScrollUp");

      if (
        tableElement &&
        navbarElement &&
        mainContainer &&
        prevScrollTop &&
        (tableSizeUnreported?.length > 0 || tableSizeOtherTabs?.length > 0)
      ) {
        const prevScroll = parseInt(prevScrollTop.value, 10);
        const currentScroll =
          tableElement.scrollTop || document.documentElement.scrollTop;
        if (tableElement.scrollTop > prevScroll) {
          navbarElement.classList.add("scrolled");
          tableSizeUnreported[0]?.classList.add("scrolled");
          tableSizeOtherTabs[0]?.classList.add("scrolled");
          mainContainer.classList.add("scrolled");
        } else {
          navbarElement.classList.remove("scrolled");
          tableSizeUnreported[0]?.classList.remove("scrolled");
          tableSizeOtherTabs[0]?.classList.remove("scrolled");
          mainContainer.classList.remove("scrolled");
        }
        prevScrollTop.value = currentScroll;
      }
    };

    const table = document.getElementById("study-list-table");
    if (table) {
      table.addEventListener("scroll", handleScroll);
    }

    return () => {
      const table = document.getElementById("study-list-table");
      if (table) {
        table.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    const tableElement = document.getElementById("study-list-table");
    const navbarElement = document.getElementById("header-nav");
    const tableSizeUnreported = document.getElementsByClassName(
      "table-height-with-xray-tab"
    );
    const tableSizeOtherTabs = document.getElementsByClassName(
      "table-height-without-xray-tab"
    );
    const mainContainer = document.getElementById("main-container-div-id");

    if (
      tableElement &&
      navbarElement &&
      mainContainer &&
      (tableSizeUnreported?.length > 0 || tableSizeOtherTabs?.length > 0)
    ) {
      navbarElement.classList.remove("scrolled");
    }
  }, [selectedValue]);

  const getSelectedStudiesTextForBulkReportDownload = () => {
    const selectedCount = Object.keys(rowSelectionState).length;
    const totalCount = dataQuery?.data?.rows?.length || 0;
    const limit = maxBulkReportDownload || totalCount;
    return `Total ${selectedCount} studies selected out of ${limit} for batch report download. `;

  }

  const getSeletedStudiesText = (batchReinferenceAndDeleteArray) => {
    switch (true) {
      case batchReinferenceAndDeleteArray.batchDeleteCount > 0 &&
        batchReinferenceAndDeleteArray.batchInferenceCount > 0:
        if (batchReinferenceAndDeleteArray.batchDeleteImageCount > 0) {
          return t("study-list.messages.batch-delete-study-image-inference", {
            batchDeleteCount: batchReinferenceAndDeleteArray.batchDeleteCount,
            study: getDynamicName(
              batchReinferenceAndDeleteArray.batchDeleteCount,
              batchReinferenceAndDeleteArray.batchInferenceCount
            ),
            batchImageCount:
              batchReinferenceAndDeleteArray.batchDeleteImageCount,
            batchInferenceCount:
              batchReinferenceAndDeleteArray.batchInferenceCount,
          });
        } else {
          return t("study-list.messages.batch-delete-inference", {
            batchDeleteCount: batchReinferenceAndDeleteArray.batchDeleteCount,
            study: getDynamicName(
              batchReinferenceAndDeleteArray.batchDeleteCount,
              batchReinferenceAndDeleteArray.batchInferenceCount
            ),
            batchInferenceCount:
              batchReinferenceAndDeleteArray.batchInferenceCount,
          });
        }
      case batchReinferenceAndDeleteArray.batchDeleteCount > 0:
        if (batchReinferenceAndDeleteArray.batchDeleteImageCount > 0) {
          return t("study-list.messages.batch-delete-study-image", {
            batchDeleteCount: batchReinferenceAndDeleteArray.batchDeleteCount,
            study: getDynamicName(
              batchReinferenceAndDeleteArray.batchDeleteCount
            ),
            batchImageCount:
              batchReinferenceAndDeleteArray.batchDeleteImageCount,
          });
        } else {
          return t("study-list.messages.batch-delete", {
            batchDeleteCount: batchReinferenceAndDeleteArray.batchDeleteCount,
            study: getDynamicName(
              batchReinferenceAndDeleteArray.batchDeleteCount
            ),
          });
        }
      case batchReinferenceAndDeleteArray.batchInferenceCount > 0:
        return t("study-list.messages.batch-inference", {
          batchInferenceCount:
            batchReinferenceAndDeleteArray.batchInferenceCount,
          study: getDynamicName(
            batchReinferenceAndDeleteArray.batchInferenceCount
          ),
        });
      case batchReinferenceAndDeleteArray.batchDeleteCount === 0 &&
        batchReinferenceAndDeleteArray.batchInferenceCount === 0:
        return t("study-list.messages.no-selection-delete-inference");
      default:
        return ``;
    }
  };

  const contextMenuStyle = useMemo(() => ({
    root: {
      backgroundColor: getThemeColor("action-details-background"),
      borderRadius: "5px",
      border: "1px solid #585858",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    item: {
      selectors: {
        ":hover": {
          backgroundColor: "green",
        },
      },
    },
  }), [getThemeColor]);

  const onHideBatchDeleteContextualMenu = useCallback(
    () => setShowBatchDeleteContextualMenu(false),
    []
  );
  const hideBatchDeleteContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowBatchDeleteContextualMenu(false);
      }, 300)
    );
  };

  const showBatchDeleteContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowBatchDeleteContextualMenu(true);
      }, 300)
    );
  };
  const batchDeleteMenuPropsItems = useMemo(() => [
    {
      key: "batch-delete-study",
      text: t("study-list.actions.delete-study"),
      title: t("study-list.actions.delete-study"),
      onClick: () => handleBatchDelete(),
    },
    {
      key: "batch-delete-image",
      text: t("study-list.actions.delete-study-image"),
      title: t("study-list.actions.delete-study-image"),
      onClick: () => handleBatchImageDelete(),
    },
  ], []);
  const hasValidOrderId = (orderId) => {
    return orderId && 
           orderId.toString().trim() !== "" && 
           orderId !== "-" && 
           orderId !== "null" && 
           orderId !== "undefined";
    };

  async function openOnSpecificScreen(url, screenIndex) {

    try {
        const screenDetails = await window.getScreenDetails();
       

        const targetScreen = screenDetails.screens[screenIndex];
        if(targetScreen.orientation.type == "landscape-primary"){
            // Open a new window on the target screen
            const newWindow = window.open(
                url, // Replace with your URL
                "_blank",
              `left=${targetScreen.availLeft},top=${targetScreen.availTop},width=${targetScreen.availWidth},height=${targetScreen.availHeight}`
            );
            return newWindow;
        } else {
            return window.open(url, "_blank");
        }
      
    } catch (error) {
        console.log("No External Monitor Found");
        console.error("Error accessing screen details:", error);;
        return window.open(url, "_blank");
    }
};

  return (
    <>
      {openImageArchiveConfirmation && (
        <ConfirmModal
          showConfirmModal={openImageArchiveConfirmation}
          title={t("image-archive.title")}
          handleNotConfirm={() => setOpenImageArchiveConfirmation(false)}
          cancelButtonText={t("confirm-message.no")}
          handleConfirm={ async () => {
            setOpenImageArchiveConfirmation(false);
            openStudy(doubleClickedRow);
            if(isVdcPlatform){
              try {
                  const response = await sendOldStudyAccessRequest2(doubleClickedRow.original.id, null, userId);
                  console.log(response.data.message);
              } catch (error) {
                console.error("Failed to access old study:", error);
              }
            } 
          }}
          confirmButtonText={t("confirm-message.yes")}
          message={t("image-archive.open-study-confirm-message")}
        />
      )}
      {openImageArchivalForm && (
        <ImageArchivalAccessForm
          openImageArchivalForm={openImageArchivalForm}
          setOpenImageArchivalForm={setOpenImageArchivalForm}
          setOpenImageArchivalAccessConfirmation={
            setOpenImageArchivalAccessConfirmation
          }
          setOpenImageArchivalAccessConfirmationMessage={
            setOpenImageArchivalAccessConfirmationMessage
          }
          row={doubleClickedRow}
          title={t("image-archive.study-archival-access")}
          message={t("image-archive.study-archival-access-message")}
          cancelButtonText={t("confirm-message.no")}
          confirmButtonText={t("confirm-message.yes")}
        />
      )}
      {openImageArchivalAccessConfirmation && (
        <ConfirmModal
          showConfirmModal={openImageArchivalAccessConfirmation}
          title={t("image-archive.study-archival-access")}
          handleCloseIcon={() => setOpenImageArchivalAccessConfirmation(false)}
          handleConfirm={() => {
            setOpenImageArchivalAccessConfirmation(false);
          }}
          confirmButtonText={t("confirm-message.ok")}
          message={openImageArchivalAccessConfirmationMessage}
        />
      )}

      {alertSuccessModal?.show && (
        <AlertSuccessModal
          isError={alertSuccessModal.isError}
          isWarning={alertSuccessModal.isWarning}
          isSuccess={alertSuccessModal.isSuccess}
          heading={alertSuccessModal.heading}
          description={alertSuccessModal.description}
          hideModal={hideAlertSuccessModal}
          isModalOpen={alertSuccessModal?.show}
        />
      )}
      {/* Added this div above the below div for studylist side padding color change */}
    <div style={{ padding: "0px 10px 8px 10px",
           background: themeName === "light" ? "#EEEEEE":"var(--studylist-search-and-tab-section-background)"
      }}>
      <div
        style={{
          background: "var(--background-theme-color)",
          "--password-expiry-offset": showPasswordExpiryMessage ? "24px" : "0px",
        }}
        id="study-list-table"
        className={`table-container study-list-modal-scroll 
        ${
          getEnv("REACT_APP_HYBRID_MODE") == "true"
            ? ((CXR_TABS_NAME.includes(props.id) || PEER_REVIEW_TABS_NAME.includes(props.id) || QC_REVIEW_TABS_NAME.includes(props.id) || ARCHIVED_STUDY_TABS_NAME.includes(props.id) || (SAVED_TABS_NAME.includes(props.id) && isBvpPlatform) || (REPORTED_TABS_NAME.includes(props.id) && (PlatformHelper.isFahes() || [USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMDOCTOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.RADIOLOGIST].includes(roles[0])))) && !contextSwitchUser
              ? maintenance?.show
                ? "hybrid-table-height-with-xray-maintenance-banner"
                : "hybrid-table-height-with-xray-tab"
              : maintenance?.show
              ? "hybrid-table-height-without-xray-maintenance-banner"
              : contextSwitchUser ? "table-height-with-contextswitch-tab" : "hybrid-table-height-without-xray-tab"
            )
            : ((CXR_TABS_NAME.includes(props.id) || PEER_REVIEW_TABS_NAME.includes(props.id) || QC_REVIEW_TABS_NAME.includes(props.id) || ARCHIVED_STUDY_TABS_NAME.includes(props.id) || (SAVED_TABS_NAME.includes(props.id) && isBvpPlatform) || (REPORTED_TABS_NAME.includes(props.id) && (PlatformHelper.isFahes() || [USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMDOCTOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.RADIOLOGIST].includes(roles[0])))) && !contextSwitchUser
            ? maintenance?.show
              ? "table-height-with-xray-maintenance-banner"
              : `${(roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN) && !REPORTED_TABS_NAME.includes(props.id) ? "study-list-firm-user" : "table-height-with-xray-tab"}`
            : maintenance?.show
            ? "table-height-without-xray-maintenance-banner"
            :contextSwitchUser? "table-height-with-contextswitch-tab" : "table-height-without-xray-tab"
        )
        } `}
        // style={{ height: props.containerHeight }}
      >
        <div
          style={{
            padding: "auto",
            height: "100%",
            width: "100%",
            zIndex: "99999",
            display: `${studyListLoading ? "flex" : "none"}`,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            opacity: "0.4",
            position: "absolute",
            top: "0",
            left: "0",
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            <ShimmerStudyRows />
          </div>

          <LoadingBar
            ref={studyListRef}
            color="#0085FF"
            height={5}
            // progress={progress}
            onLoaderFinished={() => setStudyListLoading(false)}
            containerStyle={{
              backgroundColor: "black",
              opacity: "0.8",
              position: "absolute",
              top: "0",
              left: "0",
            }}
            loaderSpeed={1000}
            transitionTime={1000}
          />
        </div>
        {!studyListLoading && (
          <>
            <div style={{ position: "relative" }}>
              {Object.keys(rowSelectionState).length > 0 && (
                <div
                  className="studylist-batch-delete-popup-container"
                  style={{
                    width:
                      getEnv("REACT_APP_HYBRID_MODE") == "true"
                        ? "98%"
                        : "91%",
                  }}
                >
                  <span className="studylist-batch-delete-text">
                    {REPORTED_TABS_NAME.includes(props.id)
                      ? getSelectedStudiesTextForBulkReportDownload()
                      : getSeletedStudiesText(batchReinferenceAndDeleteArray)
                    }
                  </span>
                  {REPORTED_TABS_NAME.includes(props.id) ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 8px' ,marginBottom: '5px'}}>
                      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '4px', marginRight: '8px' }}>
                        <span style={{ fontSize: '14px', fontWeight: 600, color: '#DFDFDF', whiteSpace: 'nowrap' }}>Report Type For: X-Ray</span>
                        <select
                          className="batch-select"
                          style={{ width: '150px' }}
                          value={xrayReportType}
                          onChange={e => setXrayReportType ? setXrayReportType(e.target.value) : null}
                        >
                          <option value="pdf">PDF</option>
                          <option value="pdfWithImage">PDF with Image</option>
                          <option value="pdfWithKeyImage">PDF with Key Image</option>
                        </select>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '4px', marginRight: '8px' }}>
                        <span style={{ fontSize: '14px', fontWeight: 600, color: '#DFDFDF', whiteSpace: 'nowrap' }}>For Others:</span>
                        <select
                          className="batch-select"
                          style={{ width: '150px' }}
                          value={nonXrayReportType}
                          onChange={e => setNonXrayReportType ? setNonXrayReportType(e.target.value) : null}
                        >
                          <option value="pdf">PDF</option>
                          <option value="pdfWithKeyImage">PDF with Key Image</option>
                        </select>
                      </div>
                      <button
                        onClick={handleBatchReportDownload}
                        className="batch-btn batch-delete-btn"
                      >
                        {t("study-list.actions.download-reports") || "Download"}&nbsp;
                      </button>
                      <button
                        onClick={() => {
                          setResetRowSelection(false);
                          props.setRowSelection({});
                        }}
                        className="toast-dismiss-btn"
                      >
                        {t("button.dismiss")}
                      </button>
                    </div>
                  ) : (
                    <>
                      {batchReinferenceAndDeleteArray.batchDeleteCount > 0 &&
                    (batchReinferenceAndDeleteArray.batchDeleteImageCount ==
                    0 ? (
                          <button
                            onClick={() => {
                                handleBatchDelete();
                            }}
                        className={`batch-btn batch-delete-btn`}
                            // disabled={!isActiveData}
                          >
                            {t("button.batch-delete")}
                          </button>
                        ) : (
                          <div
                            ref={linkRef}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "5px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setShowBatchDeleteContextualMenu((prev) => !prev);
                            }}
                            onMouseEnter={(e) => {
                              e.stopPropagation();
                              showBatchDeleteContextMenu();
                            }}
                            onMouseLeave={(e) => {
                              e.stopPropagation();
                              hideBatchDeleteContextMenu();
                        }
                      }>
                            <button
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setShowBatchDeleteContextualMenu((prev) => !prev);
                          }}
                              className="batch-btn batch-delete-btn"
                            >
                              {t("button.batch-delete")}
                            </button>
                        <div
                          onMouseLeave={(e) => {
                            e.stopPropagation();
                            clearTimeout(delayHandler);
                            setShowBatchDeleteContextualMenu(false);
                          }}
                        >
                              {showBatchDeleteContextualMenu && <ContextualMenu
                                styles={contextMenuStyle}
                                items={batchDeleteMenuPropsItems}
                                target={linkRef}
                                onItemClick={onHideBatchDeleteContextualMenu}
                                onDismiss={onHideBatchDeleteContextualMenu}
                              />}
                            </div>
                          </div>
                        ))}
                      {batchReinferenceAndDeleteArray.batchInferenceCount > 0 && (
                        <button
                          onClick={() => {
                             if(isActiveData)
                              handleBatchReInference();
                          }}
                          className={`batch-btn batch-delete-btn ${!isActiveData ? 'disabled' : ''}`}
                          disabled={!isActiveData}
                        >
                          {t("button.batch-reinference")}
                        </button>
                      )}
                    </>
                  )}
                  {!REPORTED_TABS_NAME.includes(props.id) && (
                    <button
                      onClick={() => {
                        setResetRowSelection(false);
                        props.setRowSelection({});
                      }}
                      className="toast-dismiss-btn"
                      style={{marginLeft: "10px"}}
                    >
                      {t("button.dismiss")}
                    </button>
                  )}
                </div>
              )}
            </div>
            <input type="hidden" value={0} id="prevScrollUp" />
            <table
              style={{
                width: "100%",
                borderCollapse: "inherit",
                tableLayout: ARCHIVED_STUDY_TABS_NAME.includes(props.id) ? "fixed" : "auto",
              }}
            >
              <thead className="study-list-thead">
                {table.getHeaderGroups().map((headerGroup, index) => (
                  <tr key={index}>
                    {headerGroup.headers.map((header, index) => {
                      return (
                        <React.Fragment key={index}>
                          {header.column.columnDef.show == true && (
                            <th
                              className={`study-table-th ${
                                roles[0] == USERTYPES.RADIOLOGIST
                                  ? "study-table-th-updated"
                                  : ""
                              }`}
                              key={index}
                              colSpan={header.colSpan}
                              style={header.column.columnDef.style || {}}
                            >
                              {header.isPlaceholder ? null : (
                                <>
                                  {flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                  )}
                                </>
                              )}
                            </th>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody style={{ verticalAlign: "top" }}>
                {table?.getRowModel().rows?.map((row, trIndex) => {
                  return (
                    <React.Fragment key={trIndex}>
                      <tr
                        className={`study-table-tr cursor-pointer hover-list-view-tr  $
                        {
                          trIndex % 2 == 0
                            ? "tr-alternative-color"
                            : "tr-second-alternative-color"
                        }`}
                        id={"study_id_" + row.original.id}
                        onDoubleClick={(event) => {
                          const role = props.roles[0];
                          const isCtrlClick = event.ctrlKey || event.metaKey;
                          if (
                            (role === USERTYPES.FIRMTECHNICIAN && (priviledgedFirmTechnician || showViewerTechnician)) ||
                            (role === USERTYPES.TYPIST && showViewer) ||
                            (role !== USERTYPES.FIRMTECHNICIAN && role !== USERTYPES.TYPIST)
                          ) {
                            handleStudyRowDoubleClick(row, isCtrlClick);
                          }
                        }}
                      >
                        {row.getVisibleCells().map((cell, index) => {
                          return (
                            <React.Fragment key={index}>
                              {cell.column.columnDef.show == true && (
                                <td
                                    style={{
                                        ...(cell.column.columnDef.style || {}),
                                        ...(isVdcPlatform && props.roles?.[0] === USERTYPES.RADIOLOGIST && index === 0 && row.original.orderId &&
                                            hasValidOrderId(row.original.orderId) && {
                                          backgroundColor: getOrderColor(row.original.orderId)?.background,
                                        }),
                                        ...(index === 0 && {
                                          boxSizing: "border-box",
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                          paddingLeft: "0",
                                        }),
                                      }}
                                  className={`study-table-td ${
                                    trIndex == 0
                                      ? "study-list-top-border-remove"
                                      : ""
                                  } ${
                                    cell.column.columnDef.className != undefined
                                      ? cell.column.columnDef.className
                                      : ""
                                  }`}
                                  key={index}
                                  onDoubleClick={(event) => {
                                    if (
                                      index == 0 &&
                                      (props.roles[0] == USERTYPES.ADMIN ||
                                        props.roles[0] == USERTYPES.FIRMADMIN)
                                    ) {
                                      event.stopPropagation();
                                    }
                                  }}
                                >
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}
                                </td>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tr>
                      {row.getIsExpanded()
                        ? row.subRows.map((subRow, row_index) => {
                            return (
                              <CSSTransition
                                key={row_index}
                                timeout={500}
                                classNames="fade"
                              >
                                <tr
                                  key={row_index}
                                  className={`study-table-tr  ${
                                    row_index % 2 != 0
                                      ? "tr-alternative-color-prior"
                                      : "tr-second-alternative-color-prior"
                                  }`}
                                  style={{ transition: "1s ease-in-out" }}
                                >
                                  {subRow
                                    .getVisibleCells()
                                    .map((cell, col_index) => {
                                      return (
                                        cell.column.columnDef.show == true && (
                                          <td
                                            className="study-table-td"
                                            key={col_index}
                                            style={{
                                              position:
                                                col_index == 0
                                                  ? "relative"
                                                  : "unset",
                                              borderTop: "none",
                                              // borderTopLeftRadius: `${
                                              //   row_index === 0 && col_index === 0
                                              //     ? "10px"
                                              //     : "0px"
                                              // }`,
                                              // borderBottomLeftRadius: `${
                                              //   row_index ===
                                              //     row.subRows.length - 1 &&
                                              //   col_index === 0
                                              //     ? "10px"
                                              //     : "0px"
                                              // }`,
                                              // borderTopRightRadius: `${
                                              //   row_index === 0 &&
                                              //   col_index ===
                                              //     subRow.getVisibleCells()
                                              //       .length -
                                              //       1
                                              //     ? "10px"
                                              //     : "0px"
                                              // }`,
                                              // borderBottomRightRadius: `${
                                              //   row_index ===
                                              //     row.subRows.length - 1 &&
                                              //   col_index ===
                                              //     subRow.getVisibleCells()
                                              //       .length -
                                              //       1
                                              //     ? "10px"
                                              //     : "0px"
                                              // }`,
                                            }}
                                          >
                                            {flexRender(
                                              cell.column.columnDef.cell,
                                              cell.getContext()
                                            )}
                                          </td>
                                        )
                                      );
                                    })}
                                </tr>
                              </CSSTransition>
                            );
                          })
                        : null}
                    </React.Fragment>
                  );
                })}
              </tbody>
              {dataQuery.data?.rows?.length == 0 && (
                <tbody style={{ verticalAlign: "top" }}>
                  <tr>
                    <td>
                      <div className="study-list-spinner">
                        <span className="study-list-no-data-txt">
                          {t("study-list.messages.no-result-found")}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </>
        )}
      </div>
      </div>
    </>
  );
};

export default DesktopStudyListTable;
